import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { FormTemplate } from "../../models/FormTemplate";
import { FormTemplateService } from "../../services/FormTemplateService";
import {
  FORM_CATEGORY,
  FORM_TEMPLATES_ACCESS,
  FORM_TEMP_CONSTANTS,
  FORM_TEMP_VALIDATORS
} from "../../constants/FormTemplateConstants";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  ICON_LIST_FIXED,
  LIST_DATA_EVENTS,
  VJSF_OPTIONS
} from "../../../../shared/constants/FormConstants";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import ModalTemplate from "../../../../shared/components/ModalTemplate/ModalTemplate.vue";
import AddRule from "./AddRule/AddRule.vue";
import RuleComponent from "./RuleComponent/RuleComponent.vue";
import FieldComponent from "./FieldComponent/FieldComponent.vue";
import AddFields from "./AddFields/AddFields.vue";
import AddCondition from "./AddCondition/AddCondition.vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Field } from "../../models/Field";
import { Http } from "@status/codes";
import { Response } from "@/shared/models/Response";
import firebase from "firebase/app";
import "firebase/auth";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FormRule } from "../../models/FormRule";
import { EditRule } from "../../models/EditRule";
import { FieldSummary } from "../../models/FieldSummary";
import { FormSchema } from "@/shared/models/FormSchema";
import { FieldSchema } from "@/shared/models/FieldSchema";
import { Condition } from "../../models/Condition";
import { EditConditionalField } from "../../models/EditConditionalField";
import { EditCondition } from "../../models/EditCondition";
import { EditField } from "../../models/EditField";
import { FormulaField } from "@/shared/models/FormulaField";
import { DependentData } from "@/shared/models/DependentData";
import { ConditionSchema } from "@/shared/models/ConditionSchema";
import { ManagedListsService } from "@/shared/services/ManagedListsService";
import {
  MANAGED_LISTS_TYPES,
  PANEL_INFO_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { Utils } from "@/shared/utils/utils";
import { Icon } from "@/shared/models/Icon";
import Vuetify from "vuetify";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import MultimediaManager from "@/shared/components/MultimediaManager/MultimediaManager.vue";
import { MultimediaSelected } from "@/shared/components/MultimediaManager/models/MultimediaSelected.model";
import { MULTIMEDIA_CLEANED } from "@/shared/components/MultimediaManager/constants/MultimediaManagerConstants";
import SaveList from "../../../List/components/SaveList/SaveList.vue";
import lodash from "lodash";
import { AxiosError } from "axios";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { FormTemplateSave } from "../../models/FormTemplateSave.model";

Vue.use(Vuetify);
@Component({
  name: "SaveFormTemplate",
  components: {
    FormModalViewer,
    ModalTemplate,
    AddFields,
    AddRule,
    AddCondition,
    RuleComponent,
    FieldComponent,
    ModifVJsfInput,
    MultimediaManager,
    SaveList,
    DynamicSelect
  }
})
export default class SaveFormTemplate extends Vue {
  @Inject() formTemplateService!: FormTemplateService;
  @Inject() managedListsService!: ManagedListsService;
  @Prop() private formTemplateIdProp!: string;
  @Prop({ default: false, required: false })
  public isModal!: boolean;

  formTemplate: FormTemplate = new FormTemplate();
  formTemplateToEdit: FormTemplate = new FormTemplate();
  schema: FormSchema = {
    type: "object",
    allOf: []
  };
  fieldsSchema: FieldSchema[] = [];
  columnFieldsSchema: FieldSchema[] = [];
  formSummary: FieldSummary[] = [];

  form = false;

  columnIndex: number[][] = [];
  sequenceIndex = 0;
  columnElement = false;
  modalDialog = false;
  modalTitle = "";
  modalText = "";
  modalAnswer = false;
  editing = false;
  indexEditing = -1;
  isEditingForm = false;
  formTemplateId = "";
  saved = false;
  createdBy = "";
  version!: number;
  isDraft = true;
  addFieldDialog = false;
  addRuleDialog = false;
  addConditionDialog = false;
  dialogPreview = false;
  clearModel = false;

  formCategoryList = FORM_CATEGORY;
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  blankSpaceField = [FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR];
  maxLength = [FORM_TEMP_VALIDATORS.MAX_LENGTH];
  urlPattern = [FORM_VALIDATORS.URL_PATTERN];
  listCategoryModel = [{ id: "", name: "" }];
  listIconModel = [{ id: "", value: "", name: "" }];
  helpUrl = "";
  helpText = "";
  state = "";
  formEditState = true;
  iconsList = ICON_LIST_FIXED;
  imagesList: string[] = [];
  showMoreInfo = false;
  model = {};
  messageCancel = COMPONENT_NAME_MODAL.LIST;
  formPartialSave = false;

  PAGE_TITLE = FORM_TEMP_CONSTANTS.ADD_PAGE_TITLE;
  FORM_NAME = FORM_TEMP_CONSTANTS.LABEL.FORM_NAME;
  FORM_PROMPT_SUMMARY = FORM_TEMP_CONSTANTS.LABEL.SUMMARY_PROMPT;
  URL_IMG = FORM_TEMP_CONSTANTS.LABEL.URL_IMG;
  FORM_CATEGORY = FORM_TEMP_CONSTANTS.LABEL.FORM_CATEGORY;
  FORM_STATUS = FORM_CONSTANTS.LABEL.STATE;
  HELP_TEXT = FORM_TEMP_CONSTANTS.LABEL.HELP_TEXT;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  SAVE_DRAFT_BTN = FORM_TEMP_CONSTANTS.BUTTON.SAVE_DRAFT;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  ADD_FIELD_BTN = FORM_TEMP_CONSTANTS.BUTTON.ADD_FIELD;
  ADD_RULE_BTN = FORM_TEMP_CONSTANTS.BUTTON.ADD_RULE_BTN;
  ADD_CONDITION_BTN = FORM_TEMP_CONSTANTS.BUTTON.ADD_CONDITION;
  FIELDS_TITLE = FORM_TEMP_CONSTANTS.FIELDS_TITLE;
  RULE_TITLE_DATA = FORM_TEMP_CONSTANTS.RULE_LABEL.TITLE_DATA;
  TITLE_DATA = FORM_TEMP_CONSTANTS.CONDITION_LABEL.TITLE_DATA;
  PREVIEW_BTN = FORM_CONSTANTS.BUTTON.PREVIEW;
  URL_ICON = FORM_TEMP_CONSTANTS.LABEL.URL_ICON;
  MORE_INFO = FORM_CONSTANTS.BUTTON.MORE_INFO;
  FORM_INFO = FORM_TEMP_CONSTANTS.LABEL.INFO_FORM;
  PREVIEW_TITLE = FORM_CONSTANTS.PREVIEW_TEXT;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  VJSF_OPTIONS = VJSF_OPTIONS;
  FORM_PARTIAL_SAVE = FORM_CONSTANTS.LABEL.PARTIAL_SAVE;

  priBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  textAreaClass = STYLE_CLASSES.TEXT_AREA;
  showModalAddList = false;

  conditionField: Field[] = [];
  dialogInfo = false;
  modalInfoText = FORM_MESSAGES.DELETE_FIELD_MESSAGE;
  modalInfoTitle = FORM_MESSAGES.DELETE_FIELD_TITLE;
  indexFormsCondition?: number;
  indexFields?: number;
  dataToEditField: EditField = new EditField();
  indexFieldCondition?: number = -1;
  dataToEditRule: { rule: FormRule; index: number } = {
    rule: new FormRule(),
    index: -1
  };
  indexCondition?: number = -1;
  counter = 1;
  addFieldsKey = 0;
  ruleCounter = 1;
  errorsName: string[] = [];
  dynamicSelectList: DynamicSelectData[] = [];
  dynamicSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    listAll: [],
    filled: false
  };
  iconSelectConfig: any = {
    multiple: false,
    default: [],
    listAll: [],
    chips: false,
    filled: false,
    messageLabel: this.URL_ICON,
    onlyIcon: true
  };

  formSelectConfig: any = {
    multiple: false,
    default: [],
    listAll: FORM_CATEGORY.map(category => {
      return {
        id: category,
        name: category
      };
    }),
    chips: false,
    filled: false,
    messageLabel: this.FORM_CATEGORY,
    persistenthint: true,
    required: true
  };

  formTemplateModel: FormTemplateSave = {
    name: "",
    category: "",
    icon: "",
    prompt: "",
    dateUpdatePromt: 0,
    fields: [],
    formRules: [],
    uiSetup: {
      multimedia: { ...MULTIMEDIA_CLEANED },
      helpText: ""
    },
    formConditions: [],
    partialSave: false
  };

  editComparationStr = "";
  invalidEdit = false;
  promptSummary: string | undefined;

  async mounted() {
    await this.getIconsImages();
    if (!this.isModal) {
      this.goToInit();
    }
    if (this.formTemplateIdProp) {
      this.formTemplateId = this.formTemplateIdProp;
      this.clearAddCondition();
      this.getFormTemplateById();
      this.PAGE_TITLE = FORM_TEMP_CONSTANTS.EDIT_PAGE_TITLE;
      this.isEditingForm = true;
    }
  }
  @Watch("formTemplateModel", { deep: true })
  checkEditTemplate() {
    if (this.isEditingForm) {
      this.invalidEdit =
        JSON.stringify(this.formTemplateModel) === this.editComparationStr;
    }
    return;
  }

  @Watch("formPartialSave")
  onChangeFormPartialSave() {
    this.formTemplateModel.partialSave = this.formPartialSave;
    this.checkEditTemplate();
  }

  @Watch("formTemplateIdProp")
  changeFormTemplate() {
    if (this.formTemplateIdProp !== "") {
      this.formTemplateId = this.formTemplateIdProp;
      this.clearAddCondition();
      this.getFormTemplateById();
      this.isEditingForm = true;
      this.PAGE_TITLE = FORM_TEMP_CONSTANTS.EDIT_PAGE_TITLE;
    } else {
      this.isEditingForm = false;
    }
  }

  clearAddCondition() {
    this.addFieldDialog = false;
    this.addRuleDialog = false;
    this.addConditionDialog = false;
  }

  set selectCategory(id: string) {
    const option = this.formSelectConfig.listAll.find(
      (item: any) => item.id == id
    );
    this.listCategoryModel = [
      { id: option?.id ?? "", name: option?.name ?? "" }
    ];
  }

  get selectCategory() {
    return this.listCategoryModel[0].id;
  }

  set selectIcon(value: string) {
    const option = this.iconSelectConfig.listAll.find(
      (item: any) => item.value == value
    );
    if (option != undefined) {
      this.listIconModel = [
        {
          id: option.value ?? "",
          value: option?.value ?? "",
          name: option?.name ?? ""
        }
      ];
    }
  }

  get selectIcon() {
    return this.listIconModel[0].id;
  }

  @Watch("listIconModel")
  changeIcon() {
    this.formTemplateModel.icon = this.listIconModel[0]?.id ?? "";
    this.iconsList = this.listIconModel;
  }

  @Watch("listCategoryModel")
  changeCategory() {
    this.formTemplateModel.category = this.listCategoryModel[0]?.id ?? "";
    this.iconsList = this.listIconModel;
  }

  async getIconsImages() {
    try {
      const iconResponse = await this.managedListsService.getIconsImages(
        MANAGED_LISTS_TYPES.ICONS
      );
      const imagesResponse = await this.managedListsService.getIconsImages(
        MANAGED_LISTS_TYPES.IMAGES
      );

      this.iconsList = (iconResponse.data as Icon[]) || ICON_LIST_FIXED;
      this.imagesList = (imagesResponse.data as string[]) || [];
      this.iconSelectConfig.listAll = this.iconsList.map(icon => {
        return { id: icon.value, value: icon.value, name: icon.name };
      });
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getFormTemplateById() {
    try {
      const response = await this.formTemplateService.getFormTemplateById(
        this.formTemplateId
      );

      if (response.code === Http.Found && response.data != null) {
        this.formTemplateToEdit = response.data;
        await this.fillForm();
        this.$emit("formTempName", this.formTemplateToEdit.name);
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async fillForm() {
    this.formTemplateModel.name = this.formTemplateToEdit.name;
    this.selectCategory = this.formTemplateToEdit.category;
    this.selectIcon =
      this.formTemplateToEdit.icon != undefined
        ? this.formTemplateToEdit.icon
        : "";

    this.formTemplateModel.prompt = this.formTemplateToEdit.prompt ?? "";
    this.promptSummary = this.formTemplateToEdit.prompt ?? "";
    this.formTemplateModel.category = this.formTemplateToEdit.category;
    this.formTemplateToEdit.icon =
      this.formTemplateToEdit.icon != undefined
        ? this.formTemplateToEdit.icon
        : "";

    this.formTemplateModel.fields = this.formTemplateToEdit.fields || [];
    this.formTemplateModel.formRules = this.formTemplateToEdit.formRules || [];
    this.formTemplateModel.uiSetup.multimedia =
      this.formTemplateToEdit.uiSetup &&
      this.formTemplateToEdit.uiSetup.multimedia
        ? this.formTemplateToEdit.uiSetup.multimedia
        : { ...MULTIMEDIA_CLEANED };

    this.editing =
      (this.formTemplateToEdit.uiSetup?.multimedia?._key ?? "").length > 0;

    this.formTemplateModel.uiSetup.helpText =
      this.formTemplateToEdit.uiSetup?.helpText || "";
    this.formTemplateModel.formConditions =
      this.formTemplateToEdit.formConditions || [];

    if (this.formTemplateToEdit.state !== FORM_TEMP_CONSTANTS.DRAFT_STATUS) {
      this.isDraft = false;
      this.formEditState =
        this.formTemplateToEdit.state != ""
          ? this.formTemplateToEdit.state === FORM_CONSTANTS.STATE.ACTIVE
          : this.formEditState;
    } else if (
      this.formTemplateToEdit.state === FORM_TEMP_CONSTANTS.DRAFT_STATUS
    ) {
      this.formEditState = true;
    }
    this.formPartialSave = this.formTemplateToEdit.partialSave ?? false;
    this.formTemplateModel.partialSave = this.formPartialSave;
    this.editComparationStr = JSON.stringify(this.formTemplateModel);
    this.buildFieldSchema();
  }

  addNewField(data: EditField) {
    Vue.set(
      this.formTemplateModel.fields,
      this.formTemplateModel.fields.length,
      data.formField
    );
    this.addFieldDialog = false;
  }

  addNewConditionField(data: EditField) {
    let condition: Condition;

    if (data.conditionIndex != undefined) {
      condition = this.formTemplateModel.formConditions[data.conditionIndex];
      condition.fields.push(data.formField);
      Vue.set(
        this.formTemplateModel.formConditions,
        data.conditionIndex,
        condition
      );
    }

    this.indexFieldCondition = -1;
    this.addFieldDialog = false;
  }

  addEditedField(data: EditField) {
    if (data.fieldIndex != undefined) {
      Vue.set(this.formTemplateModel.fields, data.fieldIndex, data.formField);
    }

    this.addFieldDialog = false;
    this.model = {};
    this.dataToEditField = new EditField();
  }

  addEditedConditionField(data: EditField) {
    if (
      data.conditionIndex != undefined &&
      data.fieldIndex != undefined &&
      data.preCondition != undefined
    ) {
      if (data.conditionIndex === data.preCondition) {
        Vue.set(
          this.formTemplateModel.formConditions[data.conditionIndex].fields,
          data.fieldIndex,
          data.formField
        );
      } else {
        this.formTemplateModel.formConditions[data.preCondition].fields.splice(
          data.fieldIndex,
          1
        );
        this.formTemplateModel.formConditions[data.conditionIndex].fields.push(
          data.formField
        );
      }
    }

    this.addFieldDialog = false;
  }

  closeFieldsDialog() {
    this.addFieldDialog = false;
  }

  deleteField(index: number) {
    this.addFieldDialog = false;
    const parentKey = this.formTemplateModel.fields[index].key;
    const fieldHaveCondition = this.formTemplateModel.formConditions.find(
      c => c.condition.parentField == parentKey
    );
    if (fieldHaveCondition) {
      this.dialogInfo = true;
      this.indexFields = index;
      this.modalInfoText = FORM_MESSAGES.DELETE_FIELD_MESSAGE;
      this.modalInfoTitle = FORM_MESSAGES.DELETE_FIELD_TITLE;
    } else {
      this.formTemplateModel.fields.splice(index, 1);
      this.saveNewOrder();
    }
    this.counter++;
  }

  saveNewOrder() {
    for (let i = 0; i < this.formTemplateModel.fields.length; i++) {
      const field = this.formTemplateModel.fields[i];
      field.order = i + 1;
      Vue.set(this.formTemplateModel.fields, i, field);
    }
  }

  editGivenField(index: number) {
    this.addFieldDialog = true;
    this.addConditionDialog = false;
    this.addRuleDialog = false;
    const data: EditField = {
      formField: lodash.cloneDeep(this.formTemplateModel.fields[index]),
      fieldIndex: index
    };

    this.dataToEditField = data;

    Utils.moveElement(
      "addFieldsFormTempComponent",
      "addFieldComponent" + this.formTemplateModel.fields[index].key
    );
    Utils.scrollToElement("addFieldsFormTempComponent", this);
  }

  addCondition(index: number) {
    const parentKey = this.formTemplateModel.fields[index].key;
    const fieldHaveCondition = this.formTemplateModel.formConditions.find(
      c => c.condition.parentField == parentKey
    );
    if (!fieldHaveCondition) {
      this.openConditionDialog("addConditionFormTempComponent", index);
      Utils.moveElement(
        "addConditionFormTempComponent",
        "addFieldComponent" + this.formTemplateModel.fields[index].key
      );
      Utils.scrollToElement("addConditionFormTempComponent", this);
    } else {
      Snackbar.popWarning(FORM_TEMP_CONSTANTS.MESSAGE.MAX_CONDITION_FIELD);
    }
  }

  openAddFieldCondition(index: number) {
    this.addFieldDialog = true;
    this.addConditionDialog = false;

    this.indexFieldCondition = index;

    Utils.moveElement("addFieldsFormTempComponent", "fieldsContainer");
    Utils.scrollToElement("addFieldsFormTempComponent", this);
  }

  openFieldDialog(id: string) {
    this.addFieldDialog = true;
    this.addConditionDialog = false;

    this.dataToEditField = new EditField();

    Utils.moveElement("addFieldsFormTempComponent", "fieldsContainer");
    Utils.scrollToElement(id, this);
  }

  confirmDialog(state: string) {
    if (state) {
      this.modalDialog = true;
      this.state = state;
      this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    } else {
      this.onCloseModal();
    }
  }

  async saveForm() {
    if (this.modalAnswer && this.formTemplateModel.fields.length != 0) {
      try {
        let responseForm: Response<string | void>;
        this.clearFieldListSchema();
        this.formTemplate = {
          name: this.formTemplateModel.name.trim(),
          category: this.formTemplateModel.category,
          icon: this.formTemplateModel.icon,
          fields: this.formTemplateModel.fields,
          prompt: this.formTemplateModel.prompt ?? "",
          uiSetup: {
            multimedia: {
              _key: this.formTemplateModel.uiSetup.multimedia?._key ?? ""
            },
            helpText: this.formTemplateModel.uiSetup.helpText
          },
          formRules: this.formTemplateModel.formRules,
          formConditions: this.formTemplateModel.formConditions,
          createdBy: "",
          state: this.state,
          partialSave: this.formTemplateModel.partialSave
        };
        if (this.isEditingForm) {
          this.formTemplate.createdBy = this.formTemplateToEdit.createdBy;
          this.formTemplate.changedBy = firebase.auth().currentUser?.uid;
          this.formTemplate.version = this.formTemplateToEdit.version;
          this.formTemplate.state =
            this.formTemplate.state !== FORM_TEMP_CONSTANTS.DRAFT_STATUS
              ? this.formEditState
                ? FORM_CONSTANTS.STATE.ACTIVE
                : FORM_CONSTANTS.STATE.INACTIVE
              : this.formTemplate.state;
          this.formTemplate.partialSave = this.formPartialSave;

          if (this.formTemplateModel.prompt !== this.promptSummary) {
            this.formTemplate.dateUpdatePromt = Date.now();
          }
          responseForm = await this.formTemplateService.updateFormTemplate(
            this.formTemplateId,
            this.formTemplate
          );
        } else {
          this.formTemplate.dateUpdatePromt = Date.now();
          const formTempExists = await this.formTemplateService.checkIfFormTemplateExist(
            this.formTemplateModel.name
          );

          if (formTempExists.code === Http.NotFound) {
            this.formTemplate.createdBy = firebase.auth().currentUser?.uid;

            responseForm = await this.formTemplateService.addFormTemplate(
              this.formTemplate
            );
          } else {
            Snackbar.popError(formTempExists.message);
            return;
          }
        }

        if (responseForm.code === Http.Ok) {
          this.clearForm();
          this.saved = true;
          Snackbar.popSuccess(responseForm.message);
          this.onClose();
          this.promptSummary = "";
        } else {
          Snackbar.popError(responseForm.message);
        }
      } catch (error) {
        const METHOD = Utils.getMethodHTTP(
          error as AxiosError
        ) as keyof typeof FORM_TEMPLATES_ACCESS;
        if ((error as AxiosError).response?.status == Http.Forbidden)
          Snackbar.popError(
            FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS[METHOD]
          );
        else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } else {
      Snackbar.popInfo(FORM_TEMP_CONSTANTS.MESSAGE.MIN_FIELDS);
    }

    this.modalAnswer = false;
  }

  onClose() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE);
  }

  onCloseModal() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE_MODAL);
  }

  clearFieldListSchema() {
    this.formTemplateModel.fields.forEach(field => {
      if (field.options) delete field.options;
      if (field.type === "formula") delete field.schema.oneOf;
      if (field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST) {
        delete field.schema.oneOf;
        delete field.schema.items?.enum;
        delete field.schema.items?.oneOf;
      }
    });
  }

  @Watch("fields", { deep: true })
  @Watch("formConditions", { deep: true })
  refreshSchema() {
    console.log("entreeeeeeeeeeee", this.formTemplateModel.fields);
    this.buildFieldSchema();
    this.buildSummary();
    this.model = Utils.initialModel(this.schema);
  }

  clearForm() {
    this.formTemplateModel.name = "";
    this.listCategoryModel = [];
    this.formTemplateModel.fields = [];
    this.helpUrl = "";
    this.formTemplateModel.uiSetup.helpText = "";
    this.listIconModel = [];
  }

  async handleModalAccept() {
    this.modalDialog = false;
    this.modalAnswer = true;

    if (this.modalTitle === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.saveForm();
    }
  }

  handleModalCancel() {
    this.modalDialog = false;
  }

  addNewRule(rule: EditRule) {
    Vue.set(
      this.formTemplateModel.formRules,
      this.formTemplateModel.formRules.length,
      rule.formRule
    );
    this.addRuleDialog = false;
    this.dataToEditRule = {
      rule: new FormRule(),
      index: -1
    };
  }

  addEditedRule(rule: EditRule) {
    if (rule.index != undefined) {
      Vue.set(this.formTemplateModel.formRules, rule.index, rule.formRule);
      this.addRuleDialog = false;
      this.dataToEditRule = {
        rule: new FormRule(),
        index: -1
      };
    }
  }

  closeRuleDialog() {
    this.addRuleDialog = false;
    this.dataToEditRule = {
      rule: new FormRule(),
      index: -1
    };
  }

  openRuleDialog(id: string) {
    this.addRuleDialog = true;

    this.dataToEditRule = {
      index: -1,
      rule: new FormRule()
    };

    Utils.moveElement("addRuleFormTempComponent", "rulesContainer");
    Utils.scrollToElement(id, this);
  }

  editGivenRule(index: number) {
    this.addRuleDialog = true;

    Utils.moveElement("addRuleFormTempComponent", "addRuleComponent" + index);
    this.dataToEditRule = {
      index: index,
      rule: this.formTemplateModel.formRules[index]
    };

    Utils.scrollToElement("addRuleFormTempComponent", this);
  }

  deleteRule(index: number) {
    this.formTemplateModel.formRules.splice(index, 1);
    this.ruleCounter++;
    this.addRuleDialog = false;
  }

  buildFieldSchema() {
    this.columnFieldsSchema = [];
    let formulaField: FormulaField;
    const formulaFields: FormulaField[] = [];
    this.formTemplateModel.fields.forEach(field => {
      if (field.visible) {
        formulaField = {
          key: field.key,
          schema: {
            oneOf: field.schema.oneOf ? field.schema.oneOf : undefined
          },
          type: field.type,
          formula: field.formula,
          options: field.options
        };

        formulaFields.push(formulaField);

        const required = field.required ? [field.key] : [];

        const currentField: FieldSchema = {
          properties: { [field.key]: field.schema },
          "x-cols": { md: field.width || 12 },
          required: []
        };

        const currentRequiredArray = currentField.required
          ? currentField.required
          : [];
        const newRequiredArray = required;
        currentField.required = currentRequiredArray.concat(
          newRequiredArray ? newRequiredArray : []
        );
        this.columnFieldsSchema.push(currentField);
      }
    });

    const dependentData = this.buildDependentFieldSchema();
    this.schema.allOf = this.columnFieldsSchema;
    this.schema.fields = formulaFields.concat(dependentData.fields);
    this.schema.conditions = dependentData.conditions;
  }

  buildSummary() {
    this.formSummary = this.getFieldsSummary(this.formTemplateModel.fields);
    this.formTemplateModel.formConditions.forEach(condition => {
      const summary = this.getFieldsSummary(condition.fields);
      this.formSummary = this.formSummary.concat(summary);
    });
  }

  buildDependentFieldSchema(): DependentData {
    let formulaField: FormulaField;
    const returnData: DependentData = {
      conditions: [],
      fields: []
    };
    const conditions: ConditionSchema[] = [];
    const formulaFields: FormulaField[] = [];

    this.formTemplateModel.formConditions.map(condition => {
      const conditionSchema: ConditionSchema = {
        isArray: condition.condition.isArray,
        key: condition.condition.parentField
      };
      conditions.push(conditionSchema);

      const parentKey = condition.condition.parentField;
      const index = this.columnFieldsSchema.findIndex(
        schema => schema.properties[parentKey]
      );

      const fieldSchema = this.columnFieldsSchema[index];

      if (fieldSchema != undefined) {
        fieldSchema.if = {
          required: [parentKey],
          properties: {}
        };
        if (
          condition.condition.isNumeric &&
          condition.condition.minValue != undefined &&
          condition.condition.maxValue != undefined
        ) {
          fieldSchema.if.properties = {
            [parentKey]: {
              minimum: condition.condition.minValue,
              maximum: condition.condition.maxValue
            }
          };
        } else if (
          condition.condition.isArray &&
          condition.condition.valueArray != undefined &&
          condition.condition.valueArray.length > 0
        ) {
          fieldSchema.if.properties = {
            [parentKey]: {
              const: condition.condition.valueArray
            }
          };
        } else {
          if (condition.condition.value != undefined) {
            fieldSchema.if.properties = {
              [parentKey]: {
                const: condition.condition.value
              }
            };
          }
        }

        fieldSchema.then = {
          properties: {}
        };

        condition.fields.map(field => {
          if (field.visible) {
            if (fieldSchema.then != undefined) {
              fieldSchema.then.properties[field.key] = field.schema;
            }

            formulaField = {
              key: field.key,
              schema: {
                oneOf: field.schema.oneOf ? field.schema.oneOf : undefined
              },
              type: field.type,
              formula: field.formula,
              options: field.options
            };

            formulaFields.push(formulaField);
          }
        });

        this.columnFieldsSchema[index] = fieldSchema;
      }
    });

    returnData.conditions = conditions;
    returnData.fields = formulaFields;

    return returnData;
  }

  getFieldsSummary(fields: Field[]) {
    const formSummary: FieldSummary[] = [];

    fields.forEach((field: Field) => {
      const fieldSummary: FieldSummary = {
        summary: field.summary,
        summaryText: field.summaryText,
        field: field.key
      };

      formSummary.push(fieldSummary);
    });

    return formSummary;
  }

  openConditionDialog(id: string, index?: number) {
    if (index != undefined) {
      this.conditionField = [this.formTemplateModel.fields[index]];
    } else {
      this.conditionField = this.formTemplateModel.fields;
    }

    this.indexCondition = -1;

    this.addConditionDialog = true;
    this.addFieldDialog = false;

    Utils.moveElement("addConditionFormTempComponent", "fieldsContainer");
    Utils.scrollToElement(id, this);
  }

  closeConditionDialog() {
    this.addConditionDialog = false;
    this.indexCondition = -1;
  }

  addNewCondition(condition: EditCondition) {
    Vue.set(
      this.formTemplateModel.formConditions,
      this.formTemplateModel.formConditions.length,
      condition.formCondition
    );

    this.addConditionDialog = false;
  }

  addEditedCondition(condition: EditCondition) {
    if (condition.index != undefined) {
      Vue.set(
        this.formTemplateModel.formConditions,
        condition.index,
        condition.formCondition
      );
      this.addConditionDialog = false;
    }
  }

  editGivenCondition(index: number) {
    this.addConditionDialog = true;
    this.addFieldDialog = false;
    this.conditionField = this.formTemplateModel.fields;

    this.indexCondition = index;

    Utils.moveElement(
      "addConditionFormTempComponent",
      "addCondition" +
        this.formTemplateModel.formConditions[index].condition.parentField
    );
    Utils.scrollToElement("addConditionFormTempComponent", this);
  }

  deleteCondition(index: number) {
    this.addConditionDialog = false;
    this.indexFormsCondition = index;
    if (this.formTemplateModel.formConditions[index].fields.length > 0) {
      this.dialogInfo = true;
      this.modalInfoText = FORM_MESSAGES.DELETE_CONDITION_MESSAGE;
      this.modalInfoTitle = FORM_MESSAGES.DELETE_CONDITION_TITLE;
    } else {
      this.formTemplateModel.formConditions.splice(index, 1);
    }
  }

  editGivenConditionalField(data: EditConditionalField) {
    const condition = this.formTemplateModel.formConditions[
      data.conditionIndex
    ];

    if (condition != undefined && condition.fields != undefined) {
      this.addFieldDialog = true;
      this.addConditionDialog = false;

      const newData: EditField = {
        formField: condition.fields[data.fieldIndex],
        conditionIndex: data.conditionIndex,
        fieldIndex: data.fieldIndex
      };

      this.dataToEditField = newData;
    }

    Utils.moveElement(
      "addFieldsFormTempComponent",
      "addFieldComponent" + condition.condition.parentField
    );
    Utils.scrollToElement("addFieldsFormTempComponent", this);
  }

  deleteConditionalField(data: EditConditionalField) {
    const condition = this.formTemplateModel.formConditions[
      data.conditionIndex
    ];

    if (condition != undefined && condition.fields != undefined) {
      condition.fields?.splice(data.fieldIndex, 1);
      Vue.set(
        this.formTemplateModel.formConditions,
        data.conditionIndex,
        condition
      );
    }
  }

  saveConditionalFieldOrder(conditionalIndex: number) {
    const condition = this.formTemplateModel.formConditions[conditionalIndex];

    if (condition != undefined) {
      for (let i = 0; i < condition.fields.length; i++) {
        const field = condition.fields[i];
        field.order = i + 1;
        condition.fields[i] = field;
      }

      Vue.set(
        this.formTemplateModel.formConditions,
        conditionalIndex,
        condition
      );
    }
  }

  openPreviewDialog() {
    this.dialogPreview = true;
    this.clearModel = true;
  }

  closeModalPreview() {
    this.dialogPreview = false;
    this.clearModel = false;
  }

  goToInit() {
    this.goToStart("formTemplateForm");
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }
  handleInfoModalCancel() {
    this.dialogInfo = false;
  }

  handleInfoModalAccept() {
    this.dialogInfo = false;

    if (this.modalInfoTitle == FORM_MESSAGES.DELETE_CONDITION_TITLE) {
      this.formTemplateModel.formConditions.splice(
        this.indexFormsCondition as number,
        1
      );
    } else {
      this.formTemplateModel.fields.splice(this.indexFields as number, 1);
      this.saveNewOrder();
    }
  }

  modifyCondition(action: string, index: number) {
    if (action === FORM_TEMP_CONSTANTS.EVENTS.CONDITION.EDIT) {
      this.editGivenCondition(index);
    } else if (action === FORM_TEMP_CONSTANTS.EVENTS.CONDITION.DELETE) {
      this.deleteCondition(index);
    } else if (
      action === FORM_TEMP_CONSTANTS.EVENTS.FIELD.ADD_NEW_FIELD_CONDITIONAL_FORM
    ) {
      this.openAddFieldCondition(index);
    }
  }

  modifyConditionalField(action: string, data: EditConditionalField | number) {
    if (action === FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.EDIT) {
      this.editGivenConditionalField(data as EditConditionalField);
    } else if (action === FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.DELETE) {
      this.deleteConditionalField(data as EditConditionalField);
    } else if (
      action === FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.SAVE_NEW_ORDER
    ) {
      this.saveConditionalFieldOrder(data as number);
    }
  }

  getFile(fileSelected: MultimediaSelected) {
    this.formTemplateModel.uiSetup.multimedia = fileSelected;
  }

  onCloseList() {
    this.showModalAddList = false;
  }

  callCancelModal() {
    const modalUserTemplate: SearchContextModal = {
      componentName: this.messageCancel,
      callbackHandleOperation: this.handleOperation
    };
    Utils.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
      modalUserTemplate
    );
  }

  closeAddListModal() {
    this.messageCancel = COMPONENT_NAME_MODAL.LIST;
    this.callCancelModal();
  }

  addElement() {
    this.showModalAddList = true;
  }

  async handleOperation(action: string) {
    if (action === LIST_DATA_EVENTS.CANCEL_DATA) {
      this.onCloseList();
    }
  }

  onCloseListModal() {
    this.showModalAddList = false;
    this.addFieldsKey++;
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.FORM_TEMPLATE,
      this.formTemplateModel.name
    );
  }
}
